export const ANNOUNCEMENT_STATUSES = [
    { id: false, name: 'Draft' },
    { id: true, name: 'Active' },
];
